// extracted by mini-css-extract-plugin
export default {"heading":"kjUX5","title":"AXMIE","titleThin":"zF87I","description":"KxN0T","buttonsWrapper":"fLHmo","headingButton":"Zti7B","skeleton-progress":"_6yGYC"};